/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_line_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are the lines smoothed?`)
};

const es_line_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Las líneas están suavizadas?`)
};

const de_line_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werden die Linien geglättet?`)
};

const nl_line_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worden de lijnen afgevlakt?`)
};

const fr_line_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les courbes sont-elles lissées ?`)
};

const it_line_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le linee sono smussate?`)
};

const pt_br2_line_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As linhas são suavizadas?`)
};

const pt_line_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As linhas são suavizadas?`)
};

const ja_line_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`線は平滑化されていますか？`)
};

const zh_line_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`线条是否经过平滑处理？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const line_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.line_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("line_faq_q3", locale)
	if (locale === "en") return en_line_faq_q3(inputs)
	if (locale === "es") return es_line_faq_q3(inputs)
	if (locale === "de") return de_line_faq_q3(inputs)
	if (locale === "nl") return nl_line_faq_q3(inputs)
	if (locale === "fr") return fr_line_faq_q3(inputs)
	if (locale === "it") return it_line_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_line_faq_q3(inputs)
	if (locale === "pt") return pt_line_faq_q3(inputs)
	if (locale === "ja") return ja_line_faq_q3(inputs)
	return zh_line_faq_q3(inputs)
};